import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { useWorkspaceSettingsContext } from '../../context/workspace-settings-context';
import { WorkspaceSettingsForm } from '../../components/workspace-settings-form';

export interface WorkspaceSettingsFormWizardScreenProps {
  error?: string;
  onClose: () => void;
  onUpdate: () => void;
}

export const WorkspaceSettingsFormWizardScreen = ({
  error,
  onClose,
  onUpdate
}: WorkspaceSettingsFormWizardScreenProps) => {
  const { form, view } = useWorkspaceSettingsContext();
  const { updateName, setAsDefault } = view.state.workspace?.actions || {};
  const noAbilityToEdit = !updateName && !setAsDefault;

  return (
    <WizardScreen
      onCancel={onClose}
      onUpdate={onUpdate}
      footerMode={noAbilityToEdit ? FooterMode.CREATED : FooterMode.UPDATE}
    >
      <>
        {error && <WizardFormError mb={3} />}
        <WizardFormValidationErrorSummary errors={form.errors} mb={3} />

        {noAbilityToEdit ? (
          <FormattedMessage
            id="workspaces.workspace_settings_form.no_permission_to_edit"
            defaultMessage="You do not have permission to edit this workspace."
          />
        ) : (
          <WorkspaceSettingsForm
            workspace={view.state.workspace}
            form={form}
            isCurrentDefaultWorkspace={view.state.isDefaultWorkspace}
            onNameChange={form.onChangeName}
            onDefaultWorkspaceChange={form.onChangeDefaultWorkspace}
            revalidate={form.revalidate}
          />
        )}
      </>
    </WizardScreen>
  );
};
